<template>
  <prime-accordion v-if="isMobileViewport" class="contact-associations-accordion">
    <prime-accordion-tab v-if="hasContracts" :header="contractsHeader">
      <small class="contract-chip-legend">Clicca un contratto per aprire il dettaglio in una nuova scheda.</small>
      <div class="association-cards">
        <a v-for="contratto in sortedContracts" :key="contratto.id" :href="contractDetailUrl(contratto)" target="_blank" rel="noopener noreferrer" class="association-card contract-association-card" :class="contractChipClass(contratto)" v-tooltip.top="contractTooltip(contratto)">
          <div class="association-card-header">
            <strong>{{ contratto.code }}</strong>
            <span>{{ contratto.type_state_name || contratto.label || 'Stato non disponibile' }}</span>
          </div>
          <div v-if="isSameClient(contratto)" class="association-client-match same-client">
            <i class="pi pi-check-circle" aria-hidden="true"></i>
            Stesso cliente
          </div>
          <div v-if="associationValue(contratto.nome_cliente)" class="association-card-row"><span>Cliente</span><strong>{{ associationValue(contratto.nome_cliente) }}</strong></div>
          <div v-if="associationValue(contratto.nome_rappresentante)" class="association-card-row"><span>Rappresentante</span><strong>{{ associationValue(contratto.nome_rappresentante) }}</strong></div>
          <div v-if="associationValue(contratto.code_fornitura || contratto.punti_prelievo)" class="association-card-row"><span>{{ contractPointLabel(contratto) }}</span><strong>{{ associationValue(contratto.code_fornitura || contratto.punti_prelievo) }}</strong></div>
        </a>
      </div>
    </prime-accordion-tab>
    <prime-accordion-tab v-if="hasUploads" header="Caricamenti wizard interessati">
      <div class="association-cards">
        <article v-for="caricamento in contact.caricamenti" :key="caricamento.id" class="association-card upload-association-card" v-tooltip.top="caricamento.stato_caricamento_name || 'Stato non disponibile'">
          <div class="association-card-header">
            <strong>Caricamento {{ caricamento.id }}</strong>
            <span>{{ caricamento.stato_caricamento_name || 'Stato non disponibile' }}</span>
          </div>
          <div v-if="associationItems(caricamento.nome_cliente).length" class="association-card-row"><span>Clienti</span><strong>{{ uploadListDisplay(caricamento.nome_cliente, 'cliente', 'clienti') }}</strong></div>
          <div v-if="associationValue(caricamento.nome_rappresentante)" class="association-card-row"><span>Rappresentante</span><strong>{{ associationValue(caricamento.nome_rappresentante) }}</strong></div>
          <div v-if="associationItems(caricamento.punti_prelievo).length" class="association-card-row"><span>Forniture</span><strong>{{ uploadListDisplay(caricamento.punti_prelievo, 'fornitura', 'forniture') }}</strong></div>
          <prime-button v-if="hasLongUploadLists(caricamento)" label="Mostra liste complete" icon="pi pi-eye" class="p-button-sm p-button-text association-card-action" @click="openUploadLists(caricamento)" />
        </article>
      </div>
    </prime-accordion-tab>
  </prime-accordion>

  <div
    v-else
    class="contact-associations-grid"
    :class="{
      'single-section': !(hasContracts && hasUploads),
      'inline-with-siblings': inlineWithSiblings,
    }"
  >
    <section v-if="hasContracts" class="contact-association-section">
      <h5>{{ contractsHeader }}</h5>
      <small class="contract-chip-legend">Clicca un contratto per aprire il dettaglio in una nuova scheda.</small>
      <div class="association-cards">
        <a v-for="contratto in sortedContracts" :key="contratto.id" :href="contractDetailUrl(contratto)" target="_blank" rel="noopener noreferrer" class="association-card contract-association-card" :class="contractChipClass(contratto)" v-tooltip.top="contractTooltip(contratto)">
          <div class="association-card-header">
            <strong>{{ contratto.code }}</strong>
            <span>{{ contratto.type_state_name || contratto.label || 'Stato non disponibile' }}</span>
          </div>
          <div v-if="isSameClient(contratto)" class="association-client-match same-client">
            <i class="pi pi-check-circle" aria-hidden="true"></i>
            Stesso cliente
          </div>
          <div v-if="associationValue(contratto.nome_cliente)" class="association-card-row"><span>Cliente</span><strong>{{ associationValue(contratto.nome_cliente) }}</strong></div>
          <div v-if="associationValue(contratto.nome_rappresentante)" class="association-card-row"><span>Rappresentante</span><strong>{{ associationValue(contratto.nome_rappresentante) }}</strong></div>
          <div v-if="associationValue(contratto.code_fornitura || contratto.punti_prelievo)" class="association-card-row"><span>{{ contractPointLabel(contratto) }}</span><strong>{{ associationValue(contratto.code_fornitura || contratto.punti_prelievo) }}</strong></div>
        </a>
      </div>
    </section>
    <section v-if="hasUploads" class="contact-association-section">
      <h5>Caricamenti wizard interessati</h5>
      <div class="association-cards">
        <article v-for="caricamento in contact.caricamenti" :key="caricamento.id" class="association-card upload-association-card" v-tooltip.top="caricamento.stato_caricamento_name || 'Stato non disponibile'">
          <div class="association-card-header">
            <strong>Caricamento {{ caricamento.id }}</strong>
            <span>{{ caricamento.stato_caricamento_name || 'Stato non disponibile' }}</span>
          </div>
          <div v-if="associationItems(caricamento.nome_cliente).length" class="association-card-row"><span>Clienti</span><strong>{{ uploadListDisplay(caricamento.nome_cliente, 'cliente', 'clienti') }}</strong></div>
          <div v-if="associationValue(caricamento.nome_rappresentante)" class="association-card-row"><span>Rappresentante</span><strong>{{ associationValue(caricamento.nome_rappresentante) }}</strong></div>
          <div v-if="associationItems(caricamento.punti_prelievo).length" class="association-card-row"><span>Forniture</span><strong>{{ uploadListDisplay(caricamento.punti_prelievo, 'fornitura', 'forniture') }}</strong></div>
          <prime-button v-if="hasLongUploadLists(caricamento)" label="Mostra liste complete" icon="pi pi-eye" class="p-button-sm p-button-text association-card-action" @click="openUploadLists(caricamento)" />
        </article>
      </div>
    </section>
  </div>

  <prime-dialog
    v-model:visible="uploadListsDialogVisible"
    :header="selectedUpload ? `Dettaglio caricamento ${selectedUpload.id}` : 'Dettaglio caricamento'"
    :modal="true"
    :style="{ width: '60rem', maxWidth: '95vw' }"
    :contentStyle="{ maxHeight: '70vh', overflowY: 'auto' }"
  >
    <div v-if="selectedUpload" class="upload-lists-dialog">
      <section v-if="selectedUploadClients.length" class="upload-list-section">
        <h5>Clienti ({{ selectedUploadClients.length }})</h5>
        <ol>
          <li v-for="(client, index) in selectedUploadClients" :key="`client-${index}`">{{ client }}</li>
        </ol>
      </section>
      <section v-if="selectedUploadSupplies.length" class="upload-list-section">
        <h5>Forniture ({{ selectedUploadSupplies.length }})</h5>
        <ol>
          <li v-for="(supply, index) in selectedUploadSupplies" :key="`supply-${index}`">{{ supply }}</li>
        </ol>
      </section>
    </div>
  </prime-dialog>
</template>

<script>
import PrimeAccordion from "primevue/accordion";
import PrimeAccordionTab from "primevue/accordiontab";
import PrimeButton from "primevue/button";
import PrimeDialog from "primevue/dialog";

export default {
  name: "ContactAssociationsDisplay",
  components: { PrimeAccordion, PrimeAccordionTab, PrimeButton, PrimeDialog },
  props: {
    contact: { type: Object, default: () => ({}) },
    contractsHeader: { type: String, default: "Contratti interessati" },
    inlineWithSiblings: { type: Boolean, default: false },
    currentClientId: { type: [Number, String], default: null },
  },
  data() {
    return {
      isMobileViewport: false,
      uploadListsDialogVisible: false,
      selectedUpload: null,
    };
  },
  computed: {
    hasContracts() {
      return Boolean(this.contact?.contratti?.length);
    },
    hasUploads() {
      return Boolean(this.contact?.caricamenti?.length);
    },
    hasCurrentClient() {
      return this.currentClientId !== null && this.currentClientId !== undefined && String(this.currentClientId) !== "";
    },
    sortedContracts() {
      const order = {
        "contract-chip-active": 0,
        "contract-chip-warning": 1,
        "contract-chip-neutral": 2,
        "contract-chip-inactive": 3,
      };
      return [...(this.contact?.contratti || [])].sort(
        (a, b) => order[this.contractChipClass(a)] - order[this.contractChipClass(b)]
      );
    },
    selectedUploadClients() {
      return this.associationItems(this.selectedUpload?.nome_cliente);
    },
    selectedUploadSupplies() {
      return this.associationItems(this.selectedUpload?.punti_prelievo);
    },
  },
  mounted() {
    this.updateViewport();
    window.addEventListener("resize", this.updateViewport);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateViewport);
  },
  methods: {
    updateViewport() {
      this.isMobileViewport = window.innerWidth < 768;
    },
    contractDetailUrl(contratto) {
      return `/ask/contratti/vendita/${encodeURIComponent(contratto.id)}/dettagli`;
    },
    isSameClient(contratto) {
      return this.hasCurrentClient && String(contratto.cod_cliente) === String(this.currentClientId);
    },
    associationValue(value) {
      if (Array.isArray(value)) return value.filter(Boolean).join(", ");
      return value === null || value === undefined ? "" : String(value).trim();
    },
    associationItems(value) {
      if (Array.isArray(value)) {
        return value.map((item) => String(item).trim()).filter(Boolean);
      }

      const normalized = this.associationValue(value);
      if (!normalized) return [];

      if (normalized.startsWith("[") && normalized.endsWith("]")) {
        try {
          const parsed = JSON.parse(normalized);
          if (Array.isArray(parsed)) {
            return parsed.map((item) => String(item).trim()).filter(Boolean);
          }
        } catch (error) {
          // La cache storica può essere una semplice lista separata da virgole.
        }
      }

      return normalized.split(/\s*(?:,|;|\r?\n)\s*/).filter(Boolean);
    },
    uploadListDisplay(value, singularLabel, pluralLabel) {
      const items = this.associationItems(value);
      return items.length > 3
        ? `${items.length} ${items.length === 1 ? singularLabel : pluralLabel}`
        : items.join(", ");
    },
    hasLongUploadLists(caricamento) {
      return this.associationItems(caricamento.nome_cliente).length > 3
        || this.associationItems(caricamento.punti_prelievo).length > 3;
    },
    openUploadLists(caricamento) {
      this.selectedUpload = caricamento;
      this.uploadListsDialogVisible = true;
    },
    contractPointLabel(contratto) {
      const commodity = String(contratto.code || "").slice(-1).toUpperCase();
      return commodity === "E" ? "POD" : commodity === "G" ? "PDR" : "Forniture";
    },
    contractChipClass(contratto) {
      if (Number(contratto.active) === 0) return "contract-chip-inactive";
      if (Number(contratto.cod_type_state) === 1) return "contract-chip-active";
      if (Number(contratto.cod_type_state) !== 0) return "contract-chip-warning";
      return "contract-chip-neutral";
    },
    contractTooltip(contratto) {
      const state = contratto.type_state_name || "Stato non disponibile";
      return Number(contratto.active) === 1 && Number(contratto.cod_type_state) !== 1 && Number(contratto.cod_type_state) !== 0
        ? `${contratto.label} · ${state}`
        : state;
    },
  },
};
</script>

<style scoped>
.contact-associations-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: 1rem;
  margin-top: 1.25rem;
}
.contact-associations-grid.single-section {
  grid-template-columns: minmax(0, 1fr);
}

@media screen and (min-width: 1024px) {
  .contact-associations-grid.inline-with-siblings {
    display: contents;
  }
}
.contact-associations-accordion {
  margin-top: 1.25rem;
}
.contact-association-section {
  min-width: 0;
  min-height: 100%;
  max-height: calc(85vh - 14rem);
  padding: 1rem;
  border: 1px solid var(--surface-border);
  border-radius: 6px;
  background: var(--surface-50);
  overflow-y: auto;
}
.contact-association-section h5 {
  margin: 0 0 1rem;
}
.association-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 15rem), 1fr));
  gap: 0.75rem;
  max-height: calc(85vh - 18rem);
  overflow-y: auto;
}
.contact-association-section .association-cards {
  max-height: none;
  overflow: visible;
}
.contract-chip-legend {
  display: block;
  margin-bottom: 0.75rem;
  color: var(--text-color-secondary);
}
.association-card {
  min-width: 0;
  padding: 0.75rem;
  border: 1px solid var(--surface-border);
  border-left-width: 4px;
  border-radius: 6px;
  background: var(--surface-0);
  color: var(--text-color);
}
.contract-association-card {
  display: block;
  color: inherit;
  text-decoration: none;
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}
.contract-association-card:hover {
  box-shadow: 0 4px 12px rgb(15 23 42 / 12%);
  transform: translateY(-1px);
}
.association-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.6rem;
}
.association-card-header > strong {
  color: inherit;
  overflow-wrap: anywhere;
}
.association-card-header > span {
  flex: 0 0 auto;
  color: var(--text-color-secondary);
  font-size: 0.7rem;
  text-align: right;
}
.association-client-match {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin-bottom: 0.55rem;
  padding: 0.18rem 0.5rem;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
}
.association-client-match.same-client {
  background: rgb(22 163 74 / 12%);
  color: #166534;
}
.association-card-row {
  display: grid;
  grid-template-columns: 5.75rem minmax(0, 1fr);
  gap: 0.5rem;
  padding-top: 0.35rem;
  border-top: 1px solid rgb(148 163 184 / 22%);
  font-size: 0.75rem;
}
.association-card-row + .association-card-row {
  margin-top: 0.35rem;
}
.association-card-row > span {
  color: var(--text-color-secondary);
}
.association-card-row > strong {
  overflow-wrap: anywhere;
  font-weight: 500;
}
.contract-association-card.contract-chip-active {
  background: #dcfce7;
  border-left-color: #16a34a;
  color: #166534;
}
.contract-association-card.contract-chip-warning {
  background: #fff1bd;
  border-left-color: #d97706;
  color: #854d0e;
}
.contract-association-card.contract-chip-inactive {
  background: #fbe0e0;
  border-left-color: #dc2626;
  color: #991b1b;
}
.contract-association-card.contract-chip-neutral {
  background: #e9edf2;
  border-left-color: #64748b;
  color: #475569;
}
.upload-association-card {
  border-left-color: #64748b;
}
.association-card-action {
  width: 100%;
  margin-top: 0.5rem;
  justify-content: center;
}
.upload-lists-dialog {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}
.upload-list-section {
  min-width: 0;
  padding: 1rem;
  border: 1px solid var(--surface-border);
  border-radius: 6px;
  background: var(--surface-50);
}
.upload-list-section h5 {
  margin: 0 0 0.75rem;
}
.upload-list-section ol {
  margin: 0;
  padding-left: 1.5rem;
}
.upload-list-section li {
  padding: 0.25rem 0;
  overflow-wrap: anywhere;
}
@media screen and (max-width: 767px) {
  .upload-lists-dialog {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
